export const getLastChatConversationId = state => state.chat.lastInteractiveGuid
;
